import { render, staticRenderFns } from "./SnakeCanvas.vue?vue&type=template&id=9baa2952&scoped=true&"
import script from "./SnakeCanvas.vue?vue&type=script&lang=js&"
export * from "./SnakeCanvas.vue?vue&type=script&lang=js&"
import style0 from "./SnakeCanvas.vue?vue&type=style&index=0&id=9baa2952&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9baa2952",
  null
  
)

export default component.exports